import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSort$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSort extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5c3af6cf3be68393ef2220fc0376a0ebf49accc0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e9a0094a96e41a285d2157d9daf430ddb23e15b1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a090906a03a969e30ddfedb1fb4bb4072d193229', d: "M15.683 7.874h2.284a.4.4 0 0 0 .283-.683l-3.034-3.034a.4.4 0 0 0-.566 0l-3.034 3.034a.4.4 0 0 0 .283.683h2.284v9.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zm-7.869 6.251h2.284a.4.4 0 0 1 .283.683l-3.034 3.034a.4.4 0 0 1-.566 0l-3.034-3.034a.4.4 0 0 1 .283-.683h2.284v-9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sort", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sort"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sort":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSort$1);
            }
            break;
    } });
}

const CosmosIconSort = CosmosIconSort$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSort, defineCustomElement };
